import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13.375",
  height: "12",
  viewBox: "0 0 13.375 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "sparkles-sharp-svgrepo-com 1" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M6.0625 12L5.03945 9.27305L2.3125 8.25L5.03945 7.22695L6.0625 4.5L7.08555 7.22695L9.8125 8.25L7.08555 9.27305L6.0625 12Z",
        fill: "#FFBF36"
      }),
      _createElementVNode("path", {
        id: "Vector_2",
        d: "M1.71875 3.4375L1.2584 2.1791L0 1.71875L1.2584 1.2584L1.71875 0L2.1791 1.2584L3.4375 1.71875L2.1791 2.1791L1.71875 3.4375Z",
        fill: "#FFBF36"
      }),
      _createElementVNode("path", {
        id: "Vector_3",
        d: "M11.1875 4.375L10.5799 2.79512L9 2.1875L10.5799 1.57988L11.1875 0L11.7951 1.57988L13.375 2.1875L11.7951 2.79512L11.1875 4.375Z",
        fill: "#FFBF36"
      })
    ], -1)
  ]))]))
}
export default { render: render }